import { render, staticRenderFns } from "./AdvertPosition.vue?vue&type=template&id=33bc5348"
import script from "./AdvertPosition.vue?vue&type=script&lang=js"
export * from "./AdvertPosition.vue?vue&type=script&lang=js"
import style0 from "./AdvertPosition.vue?vue&type=style&index=0&id=33bc5348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports